import {ResolveFn} from '@angular/router';
import {ApiService} from "@app/_services/api.service";
import {inject} from "@angular/core";
import {map} from "rxjs";

export const customersResolver: ResolveFn<any> = (route, state) => {
    const apiService = inject(ApiService);
    return apiService.getCustomers().pipe(map(data => ({data})));
};
